import { api } from "./api";

// logs
export const createLog = (payload) => api.post("/logs", payload).then((r) => r.data);
export const patchLog = (id, payload) => api.patch(`/logs/${id}`, payload).then((r) => r.data);
export const deleteLog = (id) => api.delete(`/logs/${id}`).then((r) => r.data);
export const getMyLogs = () => api.get("/me/logs").then((r) => r.data);
export const getShowLogs = (showId) => api.get(`/shows/${showId}/logs`).then((r) => r.data);
export const getUserLogs = (username) => api.get(`/users/${username}/logs`).then((r) => r.data);

// lists
export const createList = (payload) => api.post("/lists", payload).then((r) => r.data);
export const patchList = (id, payload) => api.patch(`/lists/${id}`, payload).then((r) => r.data);
export const deleteList = (id) => api.delete(`/lists/${id}`).then((r) => r.data);
export const getMyLists = () => api.get("/me/lists").then((r) => r.data);
export const getList = (id) => api.get(`/lists/${id}`).then((r) => r.data);
export const addToList = (listId, showId) =>
  api.post(`/lists/${listId}/items`, { showId }).then((r) => r.data);
export const removeFromList = (listId, showId) =>
  api.delete(`/lists/${listId}/items/${showId}`).then((r) => r.data);

// follows
export const followUser = (username) => api.post(`/users/${username}/follow`).then((r) => r.data);
export const unfollowUser = (username) =>
  api.delete(`/users/${username}/follow`).then((r) => r.data);
export const getFollowStatus = (username) =>
  api.get(`/users/${username}/follow-status`).then((r) => r.data);
export const getMyFollowing = () => api.get("/me/following").then((r) => r.data);
export const getUserFollowers = (username) =>
  api.get(`/users/${username}/followers`).then((r) => r.data);
export const getUserFollowing = (username) =>
  api.get(`/users/${username}/following`).then((r) => r.data);

// users
export const getUserByUsername = (username) =>
  api.get(`/users/${username}`).then((r) => r.data);

// feeds
export const getFeed = (kind, limit = 50) =>
  api.get(`/feed/${kind}`, { params: { limit } }).then((r) => r.data);

// credits
export const submitCreditSuggestion = (showId, payload) =>
  api.post(`/shows/${showId}/credit-suggestions`, payload).then((r) => r.data);
export const getMyCreditSuggestions = () =>
  api.get("/me/credit-suggestions").then((r) => r.data);

// reports
export const submitReport = (payload) =>
  api.post("/reports", payload).then((r) => r.data);

// admin
export const adminListSuggestions = (status = "pending") =>
  api.get("/admin/credit-suggestions", { params: { status } }).then((r) => r.data);
export const adminApproveSuggestion = (id) =>
  api.post(`/admin/credit-suggestions/${id}/approve`).then((r) => r.data);
export const adminRejectSuggestion = (id, reason) =>
  api.post(`/admin/credit-suggestions/${id}/reject`, { reason }).then((r) => r.data);

export const adminListShows = (params = {}) =>
  api.get("/admin/shows", { params }).then((r) => r.data);
export const adminCreateShow = (payload) =>
  api.post("/admin/shows", payload).then((r) => r.data);
export const adminPatchShow = (id, payload) =>
  api.patch(`/admin/shows/${id}`, payload).then((r) => r.data);
export const adminDeleteShow = (id) =>
  api.delete(`/admin/shows/${id}`).then((r) => r.data);

export const adminListInviteCodes = () =>
  api.get("/admin/invite-codes").then((r) => r.data);
export const adminCreateInviteCode = (payload) =>
  api.post("/admin/invite-codes", payload).then((r) => r.data);
export const adminPatchInviteCode = (id, payload) =>
  api.patch(`/admin/invite-codes/${id}`, payload).then((r) => r.data);
export const adminDeleteInviteCode = (id) =>
  api.delete(`/admin/invite-codes/${id}`).then((r) => r.data);

export const adminListReports = () =>
  api.get("/admin/reports").then((r) => r.data);

// likes
export const likeLog = (logId) => api.post(`/logs/${logId}/like`).then((r) => r.data);
export const unlikeLog = (logId) => api.delete(`/logs/${logId}/like`).then((r) => r.data);

// comments
export const getComments = (logId, { limit = 50, offset = 0 } = {}) =>
  api.get(`/logs/${logId}/comments`, { params: { limit, offset } }).then((r) => r.data);
export const createComment = (logId, text) =>
  api.post(`/logs/${logId}/comments`, { text }).then((r) => r.data);
export const deleteComment = (logId, commentId) =>
  api.delete(`/logs/${logId}/comments/${commentId}`).then((r) => r.data);

// notifications
export const getNotifications = ({ limit = 30, offset = 0 } = {}) =>
  api.get("/me/notifications", { params: { limit, offset } }).then((r) => r.data);
export const getUnreadNotifCount = () =>
  api.get("/me/notifications/unread-count").then((r) => r.data);
export const markNotifRead = (id) =>
  api.post(`/me/notifications/${id}/read`).then((r) => r.data);
export const markAllNotifRead = () =>
  api.post("/me/notifications/read-all").then((r) => r.data);
